/* eslint-disable indent */
import React from "react";
import {
  Form,
  Button,
  Select,
  Table,
  InputNumber,
  Collapse,
  Row,
  Col,
} from "antd";
import {
  PlusOutlined,
  //MinusCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { checkNumbervalue, spaceBeforeCapital } from "../../../utils";

const { Panel } = Collapse;
const { Option } = Select;

const RateComission = ({ formName, defaultRateCharge, disable }) => {
  const inputStyle = { width: "100%", borderRadius: "5px" };

  const onMaxValChange = (val, index, fieldNamePath) => {
    const slabValues = formName.getFieldValue(fieldNamePath) || [];

    if (slabValues[index + 1]) {
      slabValues[index + 1].minValue = val;
      formName.setFieldsValue({
        [fieldNamePath]: slabValues,
      });
    }
  };

  const getColumns = (fieldNamePath) => [
    {
      title: "SI",
      dataIndex: "key",
      render: (_, record, index) => index + 1,
    },
    {
      title: "Min Value",
      dataIndex: "minValue",
      render: (_, record, index) => (
        <Form.Item
          name={[index, "minValue"]}
          rules={[{ required: true, message: "Min Value is required" }]}
        >
          <InputNumber
            min={0}
            placeholder="Min Value"
            style={inputStyle}
            onKeyPress={(event) => {
              if (checkNumbervalue(event)) {
                event.preventDefault();
              }
            }}
            disabled
          />
        </Form.Item>
      ),
    },
    {
      title: "Max Value",
      dataIndex: "maxValue",
      render: (_, record, index) => (
        <Form.Item
          name={[index, "maxValue"]}
          rules={[
            { required: true, message: "Max Value is required" },

            () => ({
              validator(_, value) {
                const minValue =
                  formName.getFieldValue(fieldNamePath)?.[index]?.minValue;

                if (value <= minValue) {
                  return Promise.reject(
                    new Error(`Max Value must be greater than ${minValue}`)
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <InputNumber
            min={record.minValue || 0}
            placeholder="Max Value"
            style={inputStyle}
            onKeyPress={(event) => {
              if (checkNumbervalue(event)) {
                event.preventDefault();
              }
            }}
            onChange={(val) => onMaxValChange(val, index, fieldNamePath)}
            //onChange={(val) => onMaxValChange(val, index)}
            disabled={disable}
          />
        </Form.Item>
      ),
    },
    {
      title: "Rate",
      dataIndex: "value",
      render: (_, record, index) => (
        <Form.Item
          name={[index, "value"]}
          rules={[{ required: true, message: "Rate is required" }]}
        >
          <InputNumber
            min={0}
            placeholder="Rate"
            style={inputStyle}
            //className="input-field-style"
            onKeyPress={(event) => {
              if (checkNumbervalue(event)) {
                event.preventDefault();
              }
            }}
            disabled={disable}
          />
        </Form.Item>
      ),
    },
  ];

  return (
    <Collapse collapsible={"header"} defaultActiveKey={["1"]}>
      <Panel header="Rate Commissions" key="1">
        <Form
          form={formName}
          initialValues={{
            commission: [
              {
                rateType: "Percentage",
                chargesHead: null,
                slab: [{ minValue: 0, maxValue: null, value: null }],
              },
            ],
          }}
        >
          <Row gutter={[16, 16]}>
            <Form.List name="commission">
              {(cards, { add, remove }) => (
                <>
                  {!disable && (
                    <Col span={24}>
                      <Button
                        type="dashed"
                        onClick={() =>
                          add({
                            rateType: "Percentage",
                            chargesHead: null,
                            slab: [
                              { minValue: 0, maxValue: null, value: null },
                            ],
                          })
                        }
                        block
                        icon={<PlusOutlined />}
                        className="save-btn"
                        disabled={disable}
                        style={{ width: "auto" }}
                      >
                        Add Commission
                      </Button>
                    </Col>
                  )}

                  {cards.map((field, cardIndex) => (
                    <Col
                      span={11}
                      key={cardIndex}
                      // style={{ marginBottom: "16px" }}
                      className="commission-card"
                    >
                      <Row gutter={24}>
                        <Col span={6}>
                          <Form.Item
                            {...field}
                            //label="Rate Type"
                            name={[field.name, "rateType"]}
                            rules={[
                              {
                                required: true,
                                message: "Rate Type is required",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select Rate Type"
                              disabled={disable}
                            >
                              <Option value="Percentage">Percentage</Option>
                              <Option value="Fixed">Fixed</Option>
                            </Select>
                          </Form.Item>
                        </Col>

                        <Col span={6}>
                          <Form.Item
                            {...field}
                            //label="Charge Head"
                            name={[field.name, "chargesHead"]}
                            rules={[
                              {
                                required: true,
                                message: "Charge Head is required",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select Charge Head"
                              options={defaultRateCharge?.map((e) => ({
                                label: spaceBeforeCapital(e.head),
                                value: e.head,
                                key: e.key,
                              }))}
                              disabled={disable}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={7}>
                          {/* {!disable && cardIndex === cards?.length - 1 && (
                            <Button
                              type="dashed"
                              onClick={() =>
                                add({
                                  rateType: "Percentage",
                                  chargesHead: null,
                                  slab: [
                                    {
                                      minValue: 0,
                                      maxValue: null,
                                      value: null,
                                    },
                                  ],
                                })
                              }
                              block
                              style={{ width: "100%" }}
                              icon={<PlusOutlined />}
                              className="save-btn"
                              disabled={disable}
                            >
                              Add Commission
                            </Button>
                          )} */}
                        </Col>
                        <Col span={5}>
                          <div className="flex-end">
                            {!disable && (
                              // <MinusCircleOutlined
                              //   onClick={() => remove(cardIndex)}
                              //   style={{ fontSize: "18px", color: "red" }}
                              // />

                              <CloseCircleOutlined
                                style={{ fontSize: "16px" }}
                                onClick={() => remove(cardIndex)}
                              />
                            )}
                          </div>
                        </Col>
                      </Row>
                      <Form.List
                        name={[field.name, "slab"]}
                        initialValue={[
                          { minValue: 0, maxValue: null, value: null },
                        ]}
                      >
                        {(slabs, { add: addSlab, remove: removeSlab }) => {
                          return (
                            <>
                              <Table
                                className="rate-comission-table"
                                dataSource={slabs}
                                columns={[
                                  ...getColumns([
                                    "commission",
                                    field.name,
                                    "slab",
                                  ]),
                                  {
                                    title: "Action",
                                    render: (_, __, slabIndex) =>
                                      !disable && (
                                        // <MinusCircleOutlined
                                        //   onClick={() => removeSlab(slabIndex)}
                                        //   style={{ color: "red" }}
                                        // />
                                        <div
                                          style={{
                                            width: "25px",
                                            height: "25px",
                                            borderRadius: "50%",
                                            backgroundColor: "#EEF2FF",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                          className="pointer"
                                          onClick={() => removeSlab(slabIndex)}
                                        >
                                          <DeleteOutlined
                                            style={{ color: "#238EF8" }}
                                          />
                                        </div>
                                      ),
                                  },
                                ]}
                                pagination={false}
                                rowKey={(row) => row.index}
                                footer={() =>
                                  !disable && (
                                    <div className="center">
                                      <Button
                                        //type="dashed"
                                        className="secondary-btn mt-05"
                                        onClick={() => {
                                          // addSlab({
                                          //   minValue: null,
                                          //   maxValue: null,
                                          //   value: null,
                                          // })
                                          const slabValues =
                                            formName.getFieldValue([
                                              "commission",
                                              field.name,
                                              "slab",
                                            ]);
                                          const lastSlab =
                                            slabValues?.length > 0
                                              ? slabValues[
                                                  slabValues?.length - 1
                                                ]
                                              : {};

                                          addSlab({
                                            minValue: lastSlab?.maxValue ?? 0, // Set minValue as previous maxValue
                                            maxValue: null,
                                            value: null,
                                          });
                                        }}
                                        icon={
                                          <PlusOutlined
                                            style={{ fontWeight: 500 }}
                                          />
                                        }
                                        disabled={disable}
                                      >
                                        Add Slab
                                      </Button>
                                    </div>
                                  )
                                }
                              />
                            </>
                          );
                        }}
                      </Form.List>
                    </Col>
                  ))}
                </>
              )}
            </Form.List>
          </Row>
        </Form>
      </Panel>
    </Collapse>
  );
};

export default RateComission;
